export default "__VITE_PUBLIC_ASSET__746bf508__"